import React, { useMemo, useState, useEffect } from "react";
import { connect } from "react-redux";
import { TileLayer } from "react-leaflet";

import HeatMapLayers from "scenes/ParkStatistics/components/HeatMapLayers";
import MapActioner from "services/map/actioner";
import MapUtils from "services/map/utils";
import MapConfig from "services/map/MapConfig";

import LeafletMap from "components/LeafletMap";

function MapComponent({
  center,
  visitorCharacteristics,
  heatmapConfigFromApi,
  maxZoom,
  minZoom,
  onRecenter,
  setConfigParam,
  tilesUrl,
  zoom,
}) {
  const [leafletMap, setLeafletMap] = useState();

  const toggleHeatmap = useMemo(() => {
    return visitorCharacteristics?.catchmentAreas?.initialized;
  }, [visitorCharacteristics?.catchmentAreas?.initialized]);

  useEffect(() => {
    async function initializeData() {
      if (leafletMap) {
        onRecenter(leafletMap?.leafletElement);
      }
    }

    initializeData();
  }, [onRecenter, leafletMap]);

  function getMapRadius(currentMap) {
    return MapUtils.getRadiusInMeters(
      currentMap.getBounds().getNorthEast(),
      currentMap.getCenter()
    );
  }

  function handleZoomEnd(e) {
    const currentMap = e?.target;

    setConfigParam("currentRadius", getMapRadius(currentMap));
    setConfigParam("currentZoom", currentMap.getZoom());
  }

  function handleMoveEnd(e) {
    const currentMap = e?.target;

    setConfigParam("currentRadius", getMapRadius(currentMap));
    setConfigParam("currentPosition", currentMap.getCenter());
  }

  function handleOnLoad(e) {
    const currentMap = e?.target;

    setConfigParam("currentRadius", getMapRadius(currentMap._map));
    setConfigParam("currentPosition", currentMap._map.getCenter());
  }

  return (
    <LeafletMap
      preferCanvas
      style={{
        width: "100%",
        height: "100%",
      }}
      setMapRef={setLeafletMap}
      center={center}
      zoom={zoom}
      minZoom={minZoom}
      maxZoom={maxZoom}
      onZoomEnd={handleZoomEnd}
      onMoveEnd={handleMoveEnd}
    >
      <TileLayer url={MapConfig.defaultTileUrl} />
      <TileLayer
        url={tilesUrl}
        onLoad={handleOnLoad}
        minZoom={minZoom}
        maxZoom={maxZoom}
      />

      {toggleHeatmap && (
        <HeatMapLayers
          leafletMap={leafletMap}
          points={visitorCharacteristics?.catchmentAreas?.points}
          options={heatmapConfigFromApi}
        />
      )}
    </LeafletMap>
  );
}

const mapStateToProps = (state) => ({
  center: MapUtils.getCatchementAreasCenter(state.Map),
  contract: state.Contract.contract,
  minZoom: state.Map?.config?.visitor_characteristics?.min_zoom_allowed || 0,
  maxZoom: state.Map?.config?.visitor_characteristics?.max_zoom_allowed || 18,
  tilesUrl:
    state.Map?.config?.visitor_characteristics?.tiles_url ||
    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  heatmapConfigFromApi: state.Map?.config?.visitor_characteristics?.heatmap,
  zoom:
    state.Map?.config?.currentZoom ||
    state.Map?.config?.visitor_characteristics?.default_zoom ||
    10,
});

const mapDispatchToProps = (dispatch) => ({
  setConfigParam: (key, value) =>
    dispatch(MapActioner.setConfigParam(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);
